module.exports = __webpack_public_path__ + "static/img/s-hw-4.6fab08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-hw-4.png
// module id = +a/6
// module chunks = 1